import type { SelectOption } from '@/components/SearchableSelect';

/** WhatsApp template languages, grouped the way the editor shows them. */
export const WHATSAPP_LANGUAGES: SelectOption[] = [
  { group: 'English', value: 'en', label: 'English (en)' },
  { group: 'English', value: 'en_US', label: 'English – US (en_US)' },
  { group: 'English', value: 'en_GB', label: 'English – UK (en_GB)' },
  { group: 'Arabic & MENA', value: 'ar', label: 'Arabic (ar)' },
  { group: 'Arabic & MENA', value: 'he', label: 'Hebrew (he)' },
  { group: 'Arabic & MENA', value: 'fa', label: 'Persian (fa)' },
  { group: 'Arabic & MENA', value: 'tr', label: 'Turkish (tr)' },
  { group: 'South Asia', value: 'ur', label: 'Urdu (ur)' },
  { group: 'South Asia', value: 'hi', label: 'Hindi (hi)' },
  { group: 'South Asia', value: 'bn', label: 'Bengali (bn)' },
  { group: 'South Asia', value: 'pa', label: 'Punjabi (pa)' },
  { group: 'South Asia', value: 'ta', label: 'Tamil (ta)' },
  { group: 'South Asia', value: 'te', label: 'Telugu (te)' },
  { group: 'South Asia', value: 'ml', label: 'Malayalam (ml)' },
  { group: 'South Asia', value: 'mr', label: 'Marathi (mr)' },
  { group: 'South Asia', value: 'gu', label: 'Gujarati (gu)' },
  { group: 'Europe', value: 'es', label: 'Spanish (es)' },
  { group: 'Europe', value: 'es_AR', label: 'Spanish – Argentina (es_AR)' },
  { group: 'Europe', value: 'es_ES', label: 'Spanish – Spain (es_ES)' },
  { group: 'Europe', value: 'es_MX', label: 'Spanish – Mexico (es_MX)' },
  { group: 'Europe', value: 'fr', label: 'French (fr)' },
  { group: 'Europe', value: 'de', label: 'German (de)' },
  { group: 'Europe', value: 'it', label: 'Italian (it)' },
  { group: 'Europe', value: 'pt_BR', label: 'Portuguese – Brazil (pt_BR)' },
  { group: 'Europe', value: 'pt_PT', label: 'Portuguese – Portugal (pt_PT)' },
  { group: 'Europe', value: 'nl', label: 'Dutch (nl)' },
  { group: 'Europe', value: 'pl', label: 'Polish (pl)' },
  { group: 'Europe', value: 'ru', label: 'Russian (ru)' },
  { group: 'Europe', value: 'el', label: 'Greek (el)' },
  { group: 'Europe', value: 'mt', label: 'Maltese (mt)' },
  { group: 'Europe', value: 'sv', label: 'Swedish (sv)' },
  { group: 'Europe', value: 'nb', label: 'Norwegian (nb)' },
  { group: 'Europe', value: 'da', label: 'Danish (da)' },
  { group: 'Europe', value: 'fi', label: 'Finnish (fi)' },
  { group: 'Europe', value: 'cs', label: 'Czech (cs)' },
  { group: 'Europe', value: 'hu', label: 'Hungarian (hu)' },
  { group: 'Europe', value: 'ro', label: 'Romanian (ro)' },
  { group: 'Europe', value: 'sk', label: 'Slovak (sk)' },
  { group: 'Europe', value: 'bg', label: 'Bulgarian (bg)' },
  { group: 'Europe', value: 'hr', label: 'Croatian (hr)' },
  { group: 'Europe', value: 'sr', label: 'Serbian (sr)' },
  { group: 'East & Southeast Asia', value: 'zh_CN', label: 'Chinese – Simplified (zh_CN)' },
  { group: 'East & Southeast Asia', value: 'zh_TW', label: 'Chinese – Traditional (zh_TW)' },
  { group: 'East & Southeast Asia', value: 'zh_HK', label: 'Chinese – Hong Kong (zh_HK)' },
  { group: 'East & Southeast Asia', value: 'ja', label: 'Japanese (ja)' },
  { group: 'East & Southeast Asia', value: 'ko', label: 'Korean (ko)' },
  { group: 'East & Southeast Asia', value: 'th', label: 'Thai (th)' },
  { group: 'East & Southeast Asia', value: 'vi', label: 'Vietnamese (vi)' },
  { group: 'East & Southeast Asia', value: 'id', label: 'Indonesian (id)' },
  { group: 'East & Southeast Asia', value: 'ms', label: 'Malay (ms)' },
  { group: 'East & Southeast Asia', value: 'tl', label: 'Filipino (tl)' },
  { group: 'Africa', value: 'sw', label: 'Swahili (sw)' },
  { group: 'Africa', value: 'af', label: 'Afrikaans (af)' },
  { group: 'Africa', value: 'zu', label: 'Zulu (zu)' },
];
